var m = require('mithril');
var Model = require('../../libs/Model');
var base = require('../../../../../models/bacnet/bacnetServer');
var helpers = require('../../rest/models/formHelpers');
var loaders = require('../../layout/components/loaders');
var modal = require('../../layout/components/modal');
var scPresentation = require('../scDiscoveryPresentation');

var bacnetServer = Object.assign(Object.create(base), Model);

bacnetServer.fields = base.fields;

var BACNET_DOCS_URL = '/docs/configuration/bacnet';

var TRAFFIC_PROFILE_OPTIONS = [
  { name: 'Protected', value: 'protected' },
  { name: 'Balanced (default)', value: 'balanced' },
  { name: 'Custom', value: 'custom' }
];

var TRANSPORT_OPTIONS = [
  { name: 'BACnet/IP', value: 'bacnet-ip' },
  { name: 'BACnet Secure Connect', value: 'bacnet-sc' }
];

function isBlank(value) {
  return value === undefined || value === null || String(value).trim() === '';
}

var baseInitForm = bacnetServer.initForm;
bacnetServer.initForm = function (record, options) {
  var normalized = Object.assign({}, record || {});
  if (isBlank(normalized.trafficHandlingProfile)) {
    normalized.trafficHandlingProfile = normalized['@rid'] ? 'legacy' : 'balanced';
  }
  if (isBlank(normalized.destinationPort) && !isBlank(normalized.port)) {
    normalized.destinationPort = normalized.port;
  }
  baseInitForm.call(this, normalized, options);
  bacnetServer.scConnections = [];
  bacnetServer.scConnectionsLoading = true;
  bacnetServer.availableVmacs = [];
  bacnetServer.availableVmacsLoading = false;
  bacnetServer.availableVmacsError = '';
  bacnetServer.availableVmacsConnection = '';
  bacnetServer.targetVmacManual = false;
  bacnetServer.availableVmacRequest = (Number(bacnetServer.availableVmacRequest) || 0) + 1;
  var initRequestId = bacnetServer.availableVmacRequest;
  loaders.requestWithLoader({
    loader: 'background',
    url: '/api/v1/bacnetscconnection',
    method: 'GET'
  }).then(function (connections) {
    if (initRequestId !== bacnetServer.availableVmacRequest) return;
    bacnetServer.scConnections = connections || [];
    bacnetServer.scConnectionsLoading = false;
    m.redraw();
    if (bacnetServer.form.transport() === 'bacnet-sc' && bacnetServer.form.scConnection()) {
      return bacnetServer.loadAvailableVmacs(bacnetServer.form.scConnection());
    }
  }).catch(function () {
    if (initRequestId !== bacnetServer.availableVmacRequest) return;
    bacnetServer.scConnections = [];
  }).then(function () {
    if (initRequestId !== bacnetServer.availableVmacRequest) return;
    bacnetServer.scConnectionsLoading = false;
    m.redraw();
  });
};

bacnetServer.loadAvailableVmacs = function (connectionRid) {
  var selectedConnection = String(connectionRid || '');
  var requestId = ++bacnetServer.availableVmacRequest;
  bacnetServer.availableVmacs = [];
  bacnetServer.availableVmacsError = '';
  bacnetServer.availableVmacsConnection = '';
  if (!selectedConnection) {
    bacnetServer.availableVmacsLoading = false;
    return Promise.resolve();
  }
  bacnetServer.availableVmacsLoading = true;
  m.redraw();
  return loaders.requestWithLoader({
    loader: 'background',
    url: '/api/v1/bacnetscconnection/' + selectedConnection.replace(/^#/, '') + '/available-vmacs',
    method: 'POST',
    body: {
      timeoutMs: 3000,
      excludeServer: bacnetServer.record && bacnetServer.record['@rid'] || null
    }
  }).then(function (result) {
    if (requestId !== bacnetServer.availableVmacRequest) return;
    bacnetServer.availableVmacs = result && result.vmacs || [];
    bacnetServer.availableVmacsConnection = selectedConnection;
    var automaticVmac = scPresentation.singleAvailableVmac(
      bacnetServer.availableVmacs,
      bacnetServer.form.targetVmac()
    );
    if (!bacnetServer.targetVmacManual && automaticVmac) {
      bacnetServer.form.targetVmac(automaticVmac);
    }
  }).catch(function (error) {
    if (requestId !== bacnetServer.availableVmacRequest) return;
    bacnetServer.availableVmacs = [];
    bacnetServer.availableVmacsConnection = selectedConnection;
    bacnetServer.availableVmacsError = error && (error.error || error.message) || 'Could not discover peer VMACs.';
  }).then(function () {
    if (requestId !== bacnetServer.availableVmacRequest) return;
    bacnetServer.availableVmacsLoading = false;
    m.redraw();
  });
};

function targetVmacField() {
  var connectionRid = String(bacnetServer.form.scConnection() || '');
  if (bacnetServer.targetVmacManual) {
    return m('div', [
      helpers.text(bacnetServer, 'targetVmac', 'Destination peer/router VMAC', 'Enter the peer node or router VMAC as 12 hexadecimal characters.'),
      m('button.bn.bg-transparent.blue.pointer.pa0.mt0.mb3', {
        type: 'button',
        onclick: function () {
          bacnetServer.targetVmacManual = false;
          if (connectionRid && bacnetServer.availableVmacsConnection !== connectionRid) {
            bacnetServer.loadAvailableVmacs(connectionRid);
          }
        }
      }, 'Choose a discovered VMAC')
    ]);
  }

  var choices = scPresentation.availableVmacChoices(
    bacnetServer.availableVmacs,
    bacnetServer.form.targetVmac()
  );
  var selectedVmac = String(bacnetServer.form.targetVmac() || '').replace(/[:-]/g, '').toLowerCase();
  var selectedCandidate = (bacnetServer.availableVmacs || []).find(function (candidate) {
    return candidate && candidate.vmac === selectedVmac;
  });
  var selectedUsage = selectedCandidate
    ? Number(selectedCandidate.assignedGatewayCount)
      ? ' The selected peer is already used by ' + selectedCandidate.assignedGatewayCount +
        ' other gateway' + (Number(selectedCandidate.assignedGatewayCount) === 1 ? '' : 's') + '.'
      : ' The selected peer is unused.'
    : '';
  var placeholder = !connectionRid
    ? 'Select a hub first'
    : bacnetServer.availableVmacsLoading
    ? 'Finding available VMACs…'
    : !choices.length
    ? 'No peer VMACs found'
    : 'Select an available VMAC';
  var options = [{ name: placeholder, value: '' }].concat(choices, [
    { name: 'Enter a VMAC manually…', value: '__manual__' }
  ]);
  var status = bacnetServer.availableVmacsError
    ? bacnetServer.availableVmacsError + ' You can refresh or enter a VMAC manually.'
    : bacnetServer.availableVmacsLoading
    ? 'Listening for BACnet devices through the selected SC hub…'
    : connectionRid && bacnetServer.availableVmacsConnection === connectionRid
    ? (choices.length
      ? 'Responding peer VMACs are shown with unused peers first. A peer may be shared by multiple gateways.' + selectedUsage
      : 'No peer VMACs responded. Refresh or enter one manually.')
    : 'Select a BACnet/SC hub to discover its peer VMACs.';

  return m('div', [
    helpers.select(
      bacnetServer,
      'targetVmac',
      'Destination peer/router VMAC',
      options,
      status,
      {
        onchange: function (event) {
          if (event.target.value === '__manual__') {
            bacnetServer.targetVmacManual = true;
            bacnetServer.form.targetVmac('');
          } else {
            bacnetServer.form.targetVmac(event.target.value);
          }
        },
        disabled: !connectionRid || bacnetServer.availableVmacsLoading
      }
    ),
    connectionRid ? m('button.bn.bg-transparent.blue.pointer.pa0.mt0.mb3', {
      type: 'button',
      disabled: bacnetServer.availableVmacsLoading,
      onclick: function () { bacnetServer.loadAvailableVmacs(connectionRid); }
    }, bacnetServer.availableVmacsLoading ? 'Finding VMACs…' : 'Refresh available VMACs') : null
  ]);
}

bacnetServer.modalTitle = function (titleText) {
  return m('span.flex.items-center', [
    m('span', titleText),
    m('a.white.f3.ml2.pointer.no-underline', {
      href: BACNET_DOCS_URL,
      target: '_blank',
      rel: 'noopener noreferrer',
      title: 'Open BACnet configuration docs',
      'aria-label': 'Open BACnet configuration docs',
      onclick: function (ev) {
        if (ev) ev.stopPropagation();
      }
    }, [
      m('i.ion-ios-help-outline')
    ])
  ]);
};

bacnetServer.view = function () {
  var isSc = bacnetServer.form.transport() === 'bacnet-sc';
  var isCustomTraffic = bacnetServer.form.trafficHandlingProfile() === 'custom';
  var isLegacyTraffic = bacnetServer.form.trafficHandlingProfile() === 'legacy';
  var trafficProfileOptions = isLegacyTraffic
    ? [{ name: 'Existing traffic setting (compatibility)', value: 'legacy' }].concat(TRAFFIC_PROFILE_OPTIONS)
    : TRAFFIC_PROFILE_OPTIONS;
  var connectionOptions = [{ name: 'Select a hub', value: '' }].concat(
    (bacnetServer.scConnections || []).map(function (connection) {
      return {
        name: connection.name + (Number(connection.enabled) ? '' : ' (disabled)'),
        value: connection['@rid']
      };
    })
  );
  return m('form', { role: 'form' }, [
    bacnetServer.errorView(),
    helpers.modelSwitch(bacnetServer, 'enabled', 'Enabled', 'Disabled BACnet Hosts stay configured but do not poll.', 1, 0),
    helpers.section('Connection', [
      helpers.select(bacnetServer, 'transport', 'Transport', TRANSPORT_OPTIONS, 'Choose BACnet/IP or a reusable BACnet/SC hub profile.', {
        onchange: function (event) {
          var transport = event.target.value;
          bacnetServer.form.transport(transport);
          if (transport === 'bacnet-sc' && bacnetServer.form.scConnection()) {
            bacnetServer.loadAvailableVmacs(bacnetServer.form.scConnection());
          }
        }
      }),
      helpers.columns([
        helpers.text(bacnetServer, 'name', 'Name', 'Display name for the BACnet Host.'),
        isSc
          ? helpers.select(bacnetServer, 'scConnection', 'BACnet/SC hub', connectionOptions, bacnetServer.scConnectionsLoading ? 'Loading hubs…' : 'The local node identity and hub TLS settings are managed on BACnet/SC Hubs.', {
            oninput: function (event) {
              var connectionRid = event.target.value;
              if (connectionRid !== bacnetServer.form.scConnection()) {
                bacnetServer.form.targetVmac('');
                bacnetServer.targetVmacManual = false;
              }
              bacnetServer.form.scConnection(connectionRid);
              bacnetServer.loadAvailableVmacs(connectionRid);
            },
            disabled: bacnetServer.scConnectionsLoading
          })
          : helpers.text(bacnetServer, 'host', 'Host', 'BACnet/IP address for this BACnet Host.')
      ]),
      helpers.columns([
        isSc
          ? targetVmacField()
          : helpers.text(bacnetServer, 'destinationPort', 'Destination Port', 'BACnet/IP UDP port on the remote device or router.')
      ]),
      isSc ? m('p.moon-gray.mt0', [
        'Manage local VMAC, hub URLs, and certificates on ',
        m(m.route.Link, {
          href: '/bacnet-connections',
          onclick: function () { modal.vm.close(); }
        }, 'BACnet/SC Hubs'),
        '.'
      ]) : null
    ]),
    helpers.section('Traffic Handling', [
      helpers.select(
        bacnetServer,
        'trafficHandlingProfile',
        'Protection level',
        trafficProfileOptions,
        'Balanced is the default for new hosts. Devices inherit this setting unless marked Sensitive.'
      ),
      m('p.moon-gray.mt0.lh-copy', isLegacyTraffic
        ? 'This BACnet Host keeps its existing traffic behavior until you select and save Protected, Balanced, or Custom.'
        : isCustomTraffic
        ? 'Custom limits apply to this BACnet Host. Routed networks remain serialized independently, while the host-wide limit bounds total load.'
        : (bacnetServer.form.trafficHandlingProfile() === 'balanced'
          ? 'Balanced allows up to 4 downstream networks at once with at least 100 ms between requests on each route.'
          : 'Protected allows up to 2 downstream networks at once with at least 250 ms between requests on each route.')),
      helpers.details('Advanced', [
        !isSc
          ? helpers.text(bacnetServer, 'routingDomain', 'Routing domain', 'Optional stable identifier when multiple BACnet Hosts represent the same routed internetwork. Leave blank to isolate traffic by Host.')
          : null,
        isCustomTraffic ? helpers.columns([
          helpers.text(bacnetServer, 'trafficConcurrentDownstreamNetworks', 'Concurrent downstream networks', 'Maximum routed networks active through this BACnet Host.'),
          helpers.text(bacnetServer, 'trafficRequestSpacingMs', 'Request spacing (ms)', 'Minimum time between BACnet requests on one effective route.')
        ]) : null,
        isCustomTraffic ? helpers.columns([
          helpers.text(bacnetServer, 'trafficFailureBaseDelayMs', 'Failure recovery start (ms)', 'Initial per-device recovery delay; subsequent failures back off with jitter.'),
          helpers.text(bacnetServer, 'trafficFailureMaxDelayMs', 'Failure recovery maximum (ms)', 'Maximum per-device recovery delay.')
        ]) : null,
        isCustomTraffic ? helpers.columns([
          helpers.text(bacnetServer, 'trafficTimeoutMs', 'Request timeout (ms)', 'Maximum protected BACnet request duration.'),
          helpers.text(bacnetServer, 'trafficWhoIsMinIntervalMs', 'Who-Is minimum interval (ms)', 'Minimum spacing between Who-Is requests for this BACnet Host.')
        ]) : null
      ], isCustomTraffic)
    ])
  ]);
};

module.exports = bacnetServer;
